import { selectCurrentHotelId } from 'accessors'
import CheckCircleIcon from 'components/ReusableComponents/Icons/CheckCircle'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import ExclamationIcon from 'components/ReusableComponents/Icons/Exclamation'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import pmsApi from 'services/api/pms'

import styles from './PMSSyncStatus.module.scss'

const FeatureRow = ({ title, status, reason }) => (
  <div className={styles.featureRow} data-tip={reason} data-for="pmsSyncStatusTooltip">
    <div className={styles.featureTitle}>{title}</div>
    <div className={styles.featureStatus}>
      {status === 'Good' && <CheckCircleIcon className={styles.checkIcon} />}
      {status === 'Bad' && <CrossIcon className={styles.crossIcon} />}
      {status === 'Warn' && <ExclamationIcon className={styles.exclamationIcon} />}
    </div>
  </div>
)

const PMSSyncStatus = () => {
  // existing data

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const [pmsHealthCheckData, setPmsHealthCheckData] = useState()

  const [isLoading, setIsLoading] = useState(true)

  const [isIntegrated, setIsIntegrated] = useState()

  useEffect(() => {
    setIsLoading(true)
    pmsApi
      .healthCheck({ subsidiaryIds: currentSubsidiaryId })
      .then(res => {
        setIsLoading(false)
        setPmsHealthCheckData(res)
        setIsIntegrated(res?.[0]?.isIntegrated)
      })
      .catch(error => {
        setIsLoading(false)
        console.warn(error)
      })
  }, [currentSubsidiaryId])

  if (isLoading) return <LoadingIndicator />

  if (pmsHealthCheckData?.[0]?.reports) {
    return (
      <div className={styles.featureStatuses}>
        {!isIntegrated && (
          <>
            <div className={styles.titleHolder}>
              <span className={styles.boxTitle}>PMS sync</span>
              <span
                className={styles.statusCountPill}
                style={{ backgroundColor: '#F5E6E6', color: '#FF4545' }}
              >
                Not integrated
              </span>
            </div>
          </>
        )}
        {isIntegrated && (
          <>
            <div className={styles.titleHolder}>
              <span className={styles.boxTitle}>PMS sync</span>
              <span
                className={styles.statusCountPill}
                style={{
                  backgroundColor: pmsHealthCheckData?.[0].isAllReportsHealthy
                    ? '#D8FEDA'
                    : '#F5E6E6',
                  color: pmsHealthCheckData?.[0].isAllReportsHealthy
                    ? '#409144'
                    : '#FF4545'
                }}
              >
                {pmsHealthCheckData?.[0].isAllReportsHealthy ? 'Healthy' : 'Unhealthy'}
              </span>
            </div>
            <div className={styles.featuresHolder}>
              <div className={styles.featureGroup}>
                <ReactTooltip
                  id="pmsSyncStatusTooltip"
                  place="left"
                  type="dark"
                  effect="solid"
                />
                {pmsHealthCheckData?.[0]?.reports.map(report => (
                  <FeatureRow
                    key={report.name}
                    title={report.name}
                    status={report.isHealthy ? 'Good' : 'Bad'}
                    reason={`Last report: ${moment(report.lastUploadedOn).format(
                      'MMM DD, YYYY'
                    )}`}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    )
  }

  return null
}

export default PMSSyncStatus
